import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Typography,
  Spinner,
} from "@material-tailwind/react";
import classNames from "classnames";
import Chart from "react-apexcharts";
import { Props as IChart } from "react-apexcharts";

export const StatisticsChart = React.memo(function StatisticsChart({
  color = "blue",
  chart,
  title,
  description,
  footer = null,
  isLoading,
  containerClassName,
}: {
  color?: any;
  chart: IChart;
  title: string;
  description?: string;
  footer?: any;
  isLoading?: boolean;
  // When set, the chart is rendered inside a div with this className. Pair
  // with `chart.height = "100%"` to drive responsive sizing via Tailwind.
  containerClassName?: string;
}) {
  return (
    <Card className="border border-blue-gray-100 shadow-sm">
      <CardHeader
        variant="gradient"
        color={color}
        floated={false}
        shadow={false}
        className="z-10 overflow-visible"
      >
        {isLoading ? (
          <div className="flex h-60 w-80 items-center justify-center">
            <Spinner width={40} height={40} />
          </div>
        ) : containerClassName ? (
          <div className={containerClassName}>
            <Chart {...chart} />
          </div>
        ) : (
          <Chart {...chart} />
        )}
      </CardHeader>
      <CardBody
        className={classNames({
          "px-6 pt-0": true,
          "pb-2": !footer && !description,
        })}
      >
        <Typography variant="h6" color="blue-gray">
          {title}
        </Typography>
        {!!description && (
          <Typography
            variant="small"
            className="font-normal text-blue-gray-600"
          >
            {description}
          </Typography>
        )}
      </CardBody>
      {footer && (
        <CardFooter className="border-t border-blue-gray-50 px-6 py-5">
          {footer}
        </CardFooter>
      )}
    </Card>
  );
});

export default StatisticsChart;
